import { isEmpty } from "lodash";
import { LOCAL_FIN_SCREENER } from "./const";

export function getFinScreenerUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const FIN_SCREENER_URL = process.env.REACT_APP_FIN_SCREENER_URL && process.env.REACT_APP_FIN_SCREENER_URL !== "" ? process.env.REACT_APP_FIN_SCREENER_URL : LOCAL_FIN_SCREENER;
  if (!isEmpty(REACT_ENV)) {
    return FIN_SCREENER_URL;
  } else {
    return LOCAL_FIN_SCREENER;
  }
}

export const getFinScreenerUrlValue = () => {
  return getFinScreenerUrl();
};
